import Show from '../../Show/Show';
import { Body1Reg, Title3, TitleSpecial } from '../../../config/designSystem/typography';
import { DesignSystemButtonTertiaryButton } from '../../Button/DesignSystemTertiaryButton';
import { DropShadowMedium } from '../../DropShadows/DropShadowMedium';
import { SPACING } from '../../../config/designSystem/Spacing';
import { View } from 'react-native';


interface CTACardProps {
    emoji?: string;
    titleLabel?: string;
    mainTextLabel?: string;
    buttonLabel?: string;
    onPressButton?: () => void;
}

export const CTACard = ({ emoji, titleLabel, mainTextLabel, buttonLabel,onPressButton }: CTACardProps) => {



  return (
    // Shadow OUTSIDE the rounded background, matching Notification / ProgramCard /
    // ProgramCardWrapper. This card had it inverted -- the shadow wrapper nested INSIDE
    // the white rounded View -- so the shadow was cast by an inner square box and bled
    // across the card in every direction instead of sitting under it, with its square
    // edge showing through the white. Invisible while Android drew no shadow at all;
    // obvious the moment boxShadow started rendering.
    <DropShadowMedium>
      <View style={{backgroundColor: 'white', borderRadius: SPACING['sp-12']}}>
        <View style={{rowGap: SPACING['sp-24'], padding: SPACING['sp-16']}}>
          <Show when={!!emoji}>
            <TitleSpecial align={true}>{emoji}</TitleSpecial>
          </Show>
          <Show when={!!titleLabel}>
            <View>
              <Title3 align={true}>{titleLabel}</Title3>
            </View>
          </Show>
          <Show when={!!mainTextLabel}>
            <Body1Reg align={true}>
              {mainTextLabel}
            </Body1Reg>
          </Show>
          <Show when={!!buttonLabel}>
            <DesignSystemButtonTertiaryButton label={buttonLabel as string} onPress={onPressButton as () => void} />
          </Show>
        </View>
      </View>
    </DropShadowMedium>
  );
};

